import React, { createContext, useContext, useState } from 'react';
import NotificationToast from '../components/NotificationToast';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = ({ type, title, message, duration = 5000 }) => {
    const id = Date.now() + Math.random();
    const notification = {
      id,
      type,
      title,
      message,
      duration
    };

    setNotifications(prev => [...prev, notification]);
    return id;
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  };

  const showSuccess = (message, title = null, duration = 5000) => {
    return addNotification({ type: 'success', title, message, duration });
  };

  const showError = (message, title = null, duration = 7000) => {
    return addNotification({ type: 'error', title, message, duration });
  };

  const showWarning = (message, title = null, duration = 6000) => {
    return addNotification({ type: 'warning', title, message, duration });
  };

  const showInfo = (message, title = null, duration = 5000) => {
    return addNotification({ type: 'info', title, message, duration });
  };

  const value = {
    notifications,
    addNotification,
    removeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <NotificationToast
        notifications={notifications}
        removeNotification={removeNotification}
      />
    </NotificationContext.Provider>
  );
};

export default NotificationContext; 